import { useState, useEffect } from "react";
import { CommonType } from "../../../types";
import { getDataTypeList, getParseDataTypeList } from "../../../services/dataTypeService";

export const useDataTypes = () => {
  const [dataType, setDataType] = useState<CommonType[]>([]);
  const [parsedType, setParsedType] = useState<CommonType[]>([]);
  const [selectedParseTypeId, setSelectedParseTypeId] = useState<number | null>(null);
  const [selectedConvertTypeId, setSelectedConvertTypeId] = useState<number | null>(null);

  const selectedParseType = parsedType.find(p => p.id === selectedParseTypeId) ?? null;
  const selectedConvertType = parsedType.find(p => p.id === selectedConvertTypeId) ?? null;

  const fetchDataType = async () => {
    try {
      const response = await getDataTypeList();
      if (!response.data.success) {
        throw new Error(response.data.message);
      }
      setDataType(response.data.data);
    } catch (error) {
      throw error;
    }
  };

  const fetchParsedDataType = async () => {
    try {
      const response = await getParseDataTypeList();
      if (!response.data.success) {
        throw new Error(response.data.message);
      }
      setParsedType(response.data.data);
    } catch (error) {
      throw error;
    }
  };

  const handleParseType = (value: CommonType) => {
    setSelectedParseTypeId(value.id);
  };

  const handleConvertType = (value: CommonType) => {
    setSelectedConvertTypeId(value.id);
  };

  const resetTypes = () => {
    setSelectedParseTypeId(null);
    setSelectedConvertTypeId(null);
  };

  useEffect(() => {
    fetchDataType();
    fetchParsedDataType();
  }, []);

  return {
    dataType,
    parsedType,
    selectedParseTypeId,
    selectedConvertTypeId,
    selectedParseType,
    selectedConvertType,
    handleParseType,
    handleConvertType,
    setSelectedParseTypeId,
    setSelectedConvertTypeId,
    resetTypes,
  };
};
